import * as React from 'react';
import { LogoCentered } from 'src/app/Partials';
import { GlobalPrivateState, assignLanguage } from 'src/api';
import { connect } from 'react-redux';
import { AvailableLanguagesExtended } from 'franke-trough-dependencies';
import LegalsContentDe from './Legals.Content.de';
import LegalsContentEn from './Legals.Content.en';

export interface LegalsContentProps {
  userData: GlobalPrivateState['userData'];
}

export class LegalsContentPartial extends React.Component<LegalsContentProps, any> {
  public render() {
    const fallbackLang = assignLanguage(navigator.language as AvailableLanguagesExtended) || 'en';
    const lang: any = this.props.userData && this.props.userData.result && this.props.userData.result.lang.split('-')[0] || fallbackLang;

    return(
      <div>
        <div className="row m-0">
          <div className="content-wrap">
            <div className="mb-4">
              <LogoCentered />
            </div>
            {lang === 'de' && (
              <LegalsContentDe />
            ) || lang === 'en' && (
              <LegalsContentEn />
            ) || lang === 'fr' && (
              <LegalsContentEn />
            ) || (
              <LegalsContentDe />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export const LegalsContent = connect((state: GlobalPrivateState) => ({
  userData: state.userData
}))(LegalsContentPartial);

export default LegalsContent;